import { Component, Injector, OnInit } from "@angular/core";
import { BaseResourceFormComponent, GlobalService, LoginContabil } from "eddydata-lib";
import { TransparenciaTituloDescricaoQuadro } from "projects/eddydata-lib/src/lib/entidade/contabil/titulo-descricao-quadro-transparencia.model";
import { TransparenciaTituloDescricaoQuadroService } from "./service/transparencia-titulo-descricao-quadro.service";
import { takeUntil } from "rxjs/operators";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: 'app-transparencia-titulo-descricao-quadro',
    templateUrl: './transparencia-titulo-descricao-quadro.component.html'
})

export class TransparenciaTituloDescricaoQuadroComponent extends BaseResourceFormComponent<TransparenciaTituloDescricaoQuadro, LoginContabil> {


    /**
        * Declaração de variáveis
    */

    /**
        * Construtor com as injeções de dependencias
    */
    constructor(
        private route: ActivatedRoute,
        protected injector: Injector,
        protected globalService: GlobalService,
        protected tituloDescricaoService: TransparenciaTituloDescricaoQuadroService,
    ) {
        super(new TransparenciaTituloDescricaoQuadro(), injector, TransparenciaTituloDescricaoQuadro.converteJson, tituloDescricaoService);
        this.route.params.pipe(takeUntil(this.unsubscribe)).subscribe(params => { });
        this.login = GlobalService.obterSessaoLogin()
        this.tituloDescricaoService.obter({ 'orgao.id': this.login.orgao.id, relations: 'orgao' }).pipe(takeUntil(this.unsubscribe))
            .subscribe((res) => {
                this.entidadeForm.patchValue(res);
                this.entidade = res;
            });
    }

    protected condicoesGrid(): {} {
        const parametros = {};
        parametros['orgao.id'] = this.login.orgao.id;
        return parametros;
    }


    protected criarCamposForm(): void {
        this.entidadeForm = this.fb.group({
            id: [null],
            recebimento_covid_titulo: [null],
            recebimento_covid_descricao: [null],
            despesa_covid_titulo: [null],
            despesa_covid_descricao: [null],
            arrecadacao_receita_diaria_titulo: [null],
            arrecadacao_receita_diaria_descricao: [null],
            recebimento_fonte_recurso_titulo: [null],
            recebimento_fonte_recurso_descricao: [null],
            arrecadacao_imposto_titulo: [null],
            arrecadacao_imposto_descricao: [null],
            arrecadacao_mensal_titulo: [null],
            arrecadacao_mensal_descricao: [null],
            empenho_orcamentario_titulo: [null],
            empenho_orcamentario_descricao: [null],
            despesa_empenhada_mensal_titulo: [null],
            despesa_empenhada_mensal_descricao: [null],
            liquidacao_orcamentaria_titulo: [null],
            liquidacao_orcamentaria_descricao: [null],
            pagamento_orcamentario_titulo: [null],
            pagamento_orcamentario_descricao: [null],
            transferencia_orgao_titulo: [null],
            transferencia_orgao_descricao: [null],
            transferencia_estadual_titulo: [null],
            transferencia_estadual_descricao: [null],
            transferencia_federal_titulo: [null],
            transferencia_federal_descricao: [null],
            recebimento_extra_titulo: [null],
            recebimento_extra_descricao: [null],
            despesa_extra_titulo: [null],
            despesa_extra_descricao: [null],
            despesa_fonte_recurso_titulo: [null],
            despesa_fonte_recurso_descricao: [null],
            empenho_restos_titulo: [null],
            empenho_restos_descricao: [null],
            pagamento_extra_titulo: [null],
            pagamento_extra_descricao: [null],
            liquidacao_restos_titulo: [null],
            liquidacao_restos_descricao: [null],
            pagamento_restos_titulo: [null],
            pagamento_restos_descricao: [null],
            licitacao_titulo: [null],
            licitacao_descricao: [null],
            contrato_titulo: [null],
            contrato_descricao: [null],
            consulta_fornecedor_titulo: [null],
            consulta_fornecedor_descricao: [null],
            ata_registro_preco_titulo: [null],
            ata_registro_preco_descricao: [null],
            despesa_viagem_titulo: [null],
            despesa_viagem_descricao: [null],
            equipamento_material_permanente_titulo: [null],
            equipamento_material_permanente_descricao: [null],
            operacao_credito_titulo: [null],
            operacao_credito_descricao: [null],
            convenio_titulo: [null],
            convenio_descricao: [null],
            repasse_terceiro_setor_titulo: [null],
            repasse_terceiro_setor_descricao: [null],
            transferencia_institucional_privada_titulo: [null],
            transferencia_institucional_privada_descricao: [null],
            remuneracao_servidor_titulo: [null],
            remuneracao_servidor_descricao: [null],
            cargo_salario_titulo: [null],
            cargo_salario_descricao: [null],
            servidor_publico_credito_titulo: [null],
            servidor_publico_credito_descricao: [null],
            servidor_publico_afastado_titulo: [null],
            servidor_publico_afastado_descricao: [null],
            planejamento_orcamentario_titulo: [null],
            planejamento_orcamentario_descricao: [null],
            conta_publica_titulo: [null],
            conta_publica_descricao: [null],
            ordem_cronologica_pagamento_titulo: [null],
            ordem_cronologica_pagamento_descricao: [null],
            anexo1_titulo: [null],
            anexo1_descricao: [null],
            anexo2_titulo: [null],
            anexo2_descricao: [null],
            anexo3_titulo: [null],
            anexo3_descricao: [null],
            tributo_arrecadado_titulo: [null],
            tributo_arrecadado_descricao: [null],
            anexo_loa_titulo: [null],
            anexo_loa_descricao: [null],
            execusao_orcamentaria_titulo: [null],
            execusao_orcamentaria_descricao: [null],
            almoxarifado_titulo: [null],
            almoxarifado_descricao: [null],
            ordem_fornecimento_titulo: [null],
            ordem_fornecimento_descricao: [null],
            balancete_mensal_titulo: [null],
            balancete_mensal_descricao: [null],
            balanco_titulo: [null],
            balanco_descricao: [null],
            anexo_ensino_titulo: [null],
            anexo_ensino_descricao: [null],
            anexo_saude_titulo: [null],
            anexo_saude_descricao: [null],
            fiscais_contrato_titulo: [null],
            fiscais_contrato_descricao: [null],
            painel_obra_titulo: [null],
            painel_obra_descricao: [null],
            plano_contratacao_anual_titulo: [null],
            plano_contratacao_anual_descricao: [null],
            informacao_adicionais_titulo: [null],
            informacao_adicionais_descricao: [null],
            emenda_palamentar_titulo: [null],
            emenda_palamentar_descricao: [null],
            despesa_status_titulo: [null],
            despesa_status_descricao: [null],
            orgao: [this.login.orgao],
        });
    }

    protected parametrosExtras(): {} {
        return
    }

    protected afterSubmit() {
    }

    protected beforeSubmit() {
    }

    protected afterLoad() {
    }

    protected afterInit() {
    }
}
